import type { WidgetAppearance } from '@/lib/widget-appearance'
import WidgetAppearanceStyles from '@/components/molecules/widget-appearance'
import useGenerateGuestId from '@/hooks/useGenerateGuestId'
import ChatInterface from '../chat-interface'
import { useChatStore } from '@/store/chat.store'
import SecondChatArea from '@/components/organisms/second-chat-area'
import { cn } from '@/lib/utils'
import { useEffect, useRef, type UIEvent } from 'react'

function ChatArea({ previewAppearance }: { previewAppearance?: WidgetAppearance }) {
  useGenerateGuestId()

  const isSecondChatShown = useChatStore(state => state.isSecondChatShown)

  const scrollbarTimers = useRef(new Map<HTMLElement, ReturnType<typeof setTimeout>>())

  const showScrollbar = (event: UIEvent<HTMLDivElement>) => {
    const element = event.target
    if (!(element instanceof HTMLElement)) return

    clearTimeout(scrollbarTimers.current.get(element))
    element.dataset.scrolling = 'true'
    scrollbarTimers.current.set(
      element,
      setTimeout(() => {
        delete element.dataset.scrolling
        scrollbarTimers.current.delete(element)
      }, 800)
    )
  }

  useEffect(() => {
    const timers = scrollbarTimers.current

    return () => {
      timers.forEach((timer, element) => {
        clearTimeout(timer)
        delete element.dataset.scrolling
      })
      timers.clear()
    }
  }, [])

  return (
    <div className='widget-scrollbars bg-background flex size-full flex-1 flex-col' onScrollCapture={showScrollbar}>
      {previewAppearance !== undefined && <WidgetAppearanceStyles previewAppearance={previewAppearance} />}
      <div className={cn('flex-1 overflow-hidden', isSecondChatShown ? 'block' : 'hidden')}>
        <SecondChatArea />
      </div>

      <div className={cn('flex-1 overflow-hidden', isSecondChatShown ? 'hidden' : 'block')}>
        <ChatInterface />
      </div>
    </div>
  )
}

export default ChatArea
